import type { AssetWorkflowOptions } from '../../types';

export const editThirdPartyBillingAccount: AssetWorkflowOptions = {
  workflowKey: 'editThirdPartyBillingAccount',
  workflowType: 'editAssetWorkflow',
  assetType: 'thirdPartyBillingAccount',
  workflowIndex: 1,
  workflowName: 'Edit Third Party Billing Account',
  workflowDescription: 'Edit a third party billing account',
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Third Party Billing Account ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this third party billing account',
        description:
          'This is optional but will allow you to more easily reference this third party billing account in API calls',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'carrierSelect',
      workflowStepNavigationName: 'Carrier',
      workflowComponent: {
        singleSelect: true,
        hideServiceMethods: true,
        supportsThirdPartyBilling: true,
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this third party billing account apply to?',
        description:
          'We need to know which carrier you are using to guide you through setting up your third party billing account',
        help: `If you don't see your carrier here please contact a shipium admin `,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierId',
      },
    },
    {
      workflowStepKey: 'thirdPartyBillingAccountCredential',
      workflowStepNavigationName: 'Third Party Billing Credential',
      workflowComponent: {
        workflowComponentType: 'credentialEntry',
        thirdPartyBilling: true,
        prompt: 'Enter the credentials that will be used to bill this account',
        description: '',
        help: '',
      },
      calculatedComponentProps: {
        carrierId: {
          property: 'carrierSelect',
          type: 'workflowStep',
        },
        credentials: {
          property: 'thirdPartyCredentials',
          type: 'asset',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'thirdPartyCredentials',
      },
      workflowStepConditionalMatcher: [{ workflowStepKey: 'carrierSelect', schema: { type: 'string' } }],
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Account Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter a name for this third party billing account',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 10,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'billThirdPartyForShippingCost',
      workflowStepNavigationName: 'Label Cost Billing',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Select who will be responsible for the shipping label costs.',
        description: '',
        help: '',
        options: [
          { optionText: 'Shipper', optionValue: false },
          { optionText: '3rd Party', optionValue: true },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'billThirdPartyForShippingCost',
      },
    },
    {
      workflowStepKey: 'billThirdPartyDutiesAndTaxes',
      workflowStepNavigationName: 'Label Duty and Taxes Billing',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Select who will be responsible for duties and taxes for a shipping label.',
        description: '',
        help: '',
        options: [
          { optionText: 'Shipper', optionValue: false },
          { optionText: '3rd Party', optionValue: true },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'billThirdPartyDutiesAndTaxes',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Third Party Billing Account Summary',
        description: 'The following third party billing account will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
